import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@galaxy/core';
import { map, Observable } from 'rxjs';
import { AppConfigService } from '../../../app-config.service';

@Injectable({
  providedIn: 'root',
})
export class SsoAiChatService {
  private sessionId: string;
  private hostUrl: string;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
    private configService: AppConfigService,
  ) {
    const env = this.configService.config.environment;
    if (env == 'demo') {
      this.hostUrl = 'https://developer-center-demo.apigateway.co';
    } else if (env == 'prod') {
      this.hostUrl = 'https://developer-center-prod.apigateway.co';
    }
    this.sessionService.getSessionId().subscribe((sessionId) => {
      this.sessionId = sessionId;
    });
  }

  getSSOSuggestionSteps(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.sessionId}`,
    });

    return this.http
      .post<any>(this.hostUrl + '/developercenter.v1.SuggestSSOIntegrationService/SuggestSSOIntegration', payload, {
        headers,
      })
      .pipe(
        map((data) => {
          return data.message;
        }),
      );
  }
}
